// extracted by mini-css-extract-plugin
export var cardsTrack = "DesktopLayout-module--cardsTrack--a218b";
export var cardsWrapper = "DesktopLayout-module--cardsWrapper--01d29";
export var dark = "DesktopLayout-module--dark--dc25b";
export var fadeInAnimation = "DesktopLayout-module--fadeInAnimation--45e29";
export var light = "DesktopLayout-module--light--c03fc";
export var navArrow = "DesktopLayout-module--navArrow--1ff50";
export var next = "DesktopLayout-module--next--64a8f";
export var prev = "DesktopLayout-module--prev--eb81d";
export var sliderWrapper = "DesktopLayout-module--sliderWrapper--b05ac";
export var withTransition = "DesktopLayout-module--withTransition--a163e";